<template>
<div id="search-content">
  <div class="center">
    <h4 class="cyan-text text-darken-1">部屋を探す</h4>
    <p>現在製作中です</p>
    <ul>
      <li v-for="content in contents">
        <span class="comment-user cyan-text text-darken-1">{{ content.title }}</span>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
  name: 'SearchContent',
  data(){
    return{
    contents:[],
    content: null,

    }
  },
    created(){
    db.collection('contents').get()
    .then(snapshot =>{
      snapshot.forEach(doc =>{
        let content = doc.data()
        content.id = doc.id
        this.contents.push(content)
      })
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/contents/SearchContent.vue